<template>
  <figure class="highcharts-figure">
    <highcharts ref="chart" :options="options" />
    <p class="highcharts-description highcharts-linked-description">
      <strong>Figure : </strong>
      {{ $t('compGraphicsCommutesDistancesModes.help') }}
    </p>
  </figure>
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'CommutesDistaancesModes',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    series: function () {
      let series = [
        {
          name: this.$t('walking'),
          data: new Array(30).fill(0)
        },
        {
          name: this.$t('bike'),
          data: new Array(30).fill(0)
        },
        {
          name: this.$t('2wheelers'),
          data: new Array(30).fill(0)
        },
        {
          name: this.$t('car'),
          data: new Array(30).fill(0)
        },
        {
          name: this.$t('public.transportation'),
          data: new Array(30).fill(0)
        }
      ]
      let graphicModes = {
        walking: 'walking',
        bike: 'bike',
        ebike: 'bike',
        escooter: '2wheelers',
        motorbike: '2wheelers',
        car: 'car',
        bus: 'public.transportation',
        busintercity: 'public.transportation',
        tram: 'public.transportation',
        train: 'public.transportation',
        expressrailway: 'public.transportation',
        subway: 'public.transportation',
        cablecar: 'public.transportation'
      }
      for (let commute of this.ghgi.commutes) {
        if (!commute.cdeleted) {
          for (let section of commute.sections) {
            let nday = commute.nWorkingDay1
            if (section.isDay2) {
              nday = commute.nWorkingDay2
            }
            let category = this.getCategory(section.distance)
            let seriesName = this.$t(graphicModes[section.mode])
            let index = series.findIndex((obj) => obj.name === seriesName)
            if (category > 0) {
              series[index].data[category] += nday
            }
          }
        }
      }
      return series
    },
    categories: function () {
      let categories = []
      for (let i of [...Array(30).keys()]) {
        if (i === 25) {
          categories[i] = '25-30 km'
        } else if (i === 26) {
          categories[i] = '30-35 km'
        } else if (i === 27) {
          categories[i] = '35-40 km'
        } else if (i === 28) {
          categories[i] = '40-50 km'
        } else if (i === 29) {
          categories[i] = '>50 km'
        } else {
          let sup = i + 1
          categories[i] = i + '-' + sup + ' km'
        }
      }
      return categories
    },
    options: function () {
      let self = this
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.categories
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">\u25CF</span>{series.name}: <b>{point.y}</b> ' +
            self.$t('compGraphicsCommutesDistancesModes.tooltip') +
            ' ({point.percentage:.0f}%)<br/>',
          shared: true
        },
        plotOptions: {
          column: {
            stacking: 'percent'
          }
        },
        yAxis: [
          {
            gridLineWidth: 0,
            title: {
              text: this.$t('compGraphicsCommutesDistancesModes.label-1')
            },
            labels: {
              format: '{value}%'
            }
          }
        ],
        series: this.series
      }
    }
  },
  methods: {
    getCategory (value) {
      let category = Math.floor(value)
      if (category >= 25 && category < 30) {
        category = 25
      } else if (category >= 30 && category < 35) {
        category = 26
      } else if (category >= 35 && category < 40) {
        category = 27
      } else if (category >= 40 && category < 50) {
        category = 28
      } else if (category >= 50) {
        category = 29
      }
      return category
    }
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
